const config = {
	api: 'https://ust-testing2.beautitag.com/summercamp/api',
	appPath: '/summercamp/app',
	loginTimeout: 18000000
};

export default config;